import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "./Auth.css";

function Register() {
	const [formData, setFormData] = useState({
		email: "",
		password: "",
		confirmPassword: "",
	});
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	const { register } = useAuth();
	const navigate = useNavigate();

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	async function handleSubmit(e) {
		e.preventDefault();

		if (formData.password !== formData.confirmPassword) {
			return setError("Passwords do not match");
		}

		try {
			setError("");
			setLoading(true);
			await register(formData.email, formData.password);
			navigate("/");
		} catch (error) {
			setError(error.message);
		}
		setLoading(false);
	}

	return (
		<div className="main-container">
			<div className="video-background">
				<video autoPlay loop muted playsInline>
					<source src="/images/49a01d274a.mp4" type="video/mp4" />
				</video>
			</div>

			<div className="auth-container">
				<h1>Create Account</h1>
				{error && <div className="error">{error}</div>}
				<form onSubmit={handleSubmit} className="auth-form">
					<input
						type="email"
						name="email"
						placeholder="Email"
						value={formData.email}
						onChange={handleChange}
						required
					/>
					<input
						type="password"
						name="password"
						placeholder="Password"
						value={formData.password}
						onChange={handleChange}
						required
					/>
					<input
						type="password"
						name="confirmPassword"
						placeholder="Confirm Password"
						value={formData.confirmPassword}
						onChange={handleChange}
						required
					/>
					<button disabled={loading} type="submit">
						Register
						<FontAwesomeIcon
							icon={faArrowRight}
							style={{ marginLeft: "10px" }}
						/>
					</button>
				</form>
				<div className="auth-switch">
					Already have an account? <Link to="/login">Login</Link>
				</div>
			</div>
		</div>
	);
}

export default Register;
